import { DropdownMenu, Flex } from "@nulogy/components";
import ExportScheduleContainer from "components/pages/exports/ExportScheduleContainer";
import exportUrlBuilder from "components/pages/exports/exportUrlBuilder";
import PublishSummaryModal from "components/pages/schedule/publish/PublishSummaryModal";
import React from "react";
import styled, { useTheme } from "styled-components";
import useTimeZone from "../../../hooks/useTimeZone";
import ExportModal from "./ExportModal";
import Legend from "./Legend";
import LegendModal from "./LegendModal";
import PublishDropdown from "./publish/PublishDropdown";
import PublishScheduleModal from "./publish/PublishScheduleModal";
import PublishWorkBlockModal from "./publish/PublishWorkBlockModal";
import PublishWorkOrderDatesModal from "./publish/PublishWorkOrderDatesModal";
import ZoomPicker from "./ZoomPicker";

const Controls = styled(Flex)`
  > * {
    margin: 0 ${({ theme }) => theme.space.x1};
  }

  @media only screen and (max-width: 1124px) {
    display: none;
  }
`;

const CollapsedControls = styled(Flex)`
  padding-right: ${({ theme }) => theme.space.x1};
  display: inline;

  @media only screen and (min-width: 1124px) {
    display: none;
  }
`;

export default function ScheduleHeaderView(props) {
  const {
    disabled,
    onDateChange,
    onQuickNavigationChange,
    onZoomLevelChange,
    zoomLevel,
    canPublishSchedule,
    visibleTimeRange,
  } = props;

  const [isLegendModalOpen, setLegendModalOpen] = React.useState(false);
  const [isExportScheduleModalOpen, setExportScheduleModalOpen] = React.useState(false);

  const { overrideToSiteTimeZone } = useTimeZone();

  const theme = useTheme();

  const handleExport = ({ dateRange, includeUnavailability }) => {
    const urlBuilder = exportUrlBuilder(overrideToSiteTimeZone);
    window.location = urlBuilder(dateRange, includeUnavailability);

    setExportScheduleModalOpen(false);
  };

  return (
    <Flex justifyContent="space-between">
      <PublishSummaryModal />
      <PublishScheduleModal />
      <PublishWorkBlockModal />
      <PublishWorkOrderDatesModal />
      <LegendModal isLegendModalOpen={isLegendModalOpen} setLegendModalOpen={setLegendModalOpen} />
      <ExportModal
        isExportScheduleModalOpen={isExportScheduleModalOpen}
        onExport={handleExport}
        setExportScheduleModalOpen={setExportScheduleModalOpen}
      />
      <ZoomPicker
        disabled={disabled}
        onDateChange={onDateChange}
        onQuickNavigationChange={onQuickNavigationChange}
        onZoomLevelChange={onZoomLevelChange}
        visibleTimeRange={visibleTimeRange}
        zoomLevel={zoomLevel}
      />

      <CollapsedControls>
        <DropdownMenu ml={theme.space.x1} placement="bottom-end" showArrow={false}>
          {({ closeMenu }) => (
            <>
              {canPublishSchedule && <PublishDropdown isInDropDown />}
              <ExportScheduleContainer
                closeMenu={closeMenu}
                isInDropDown
                setExportScheduleModalOpen={setExportScheduleModalOpen}
              />
              <Legend closeMenu={closeMenu} isInDropDown setLegendModalOpen={setLegendModalOpen} />
            </>
          )}
        </DropdownMenu>
      </CollapsedControls>

      <Controls alignItems="flex-start" marginX="x2">
        <Legend setLegendModalOpen={setLegendModalOpen} />
        {canPublishSchedule && <PublishDropdown />}
        <ExportScheduleContainer setExportScheduleModalOpen={setExportScheduleModalOpen} />
      </Controls>
    </Flex>
  );
}
